import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Notification } from 'base-ui'

export const ProductPagePrivatePrescriptionNotification: FC = () => {
  return (
    <Notification
      className="mt-2"
      data-qa-id="add-to-cart-cta-notification"
      severity="info"
    >
      <FormattedMessage id="pdp.messages.info.privatePrescriptionNotCombinableWithERX" />
    </Notification>
  )
}
